export default __webpack_public_path__ + "static/ASLA_Tonyo_3-0e5ec8b8c01397de897615de31413275.png";